module.exports = __webpack_public_path__ + "static/media/scarecrow.bf76e3c9.svg";